var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSphereTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 992 870"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-top_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.067%",
    y1: "40.272%",
    x2: "161.749%",
    y2: "40.272%",
    id: "sphere-top_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394A63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B6A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-top_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3E55",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80AFE5",
    offset: "52.729%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22767C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-top_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3E55",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80AFE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23%",
    y: "-21.8%",
    width: "146%",
    height: "146%",
    filterUnits: "objectBoundingBox",
    id: "sphere-top_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.725490196 0 0 0 0 0.894117647 0 0 0 0 0.890196078 0 0 0 0.234320367 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "sphere-top_svg__f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "sphere-top_svg__i"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.123%",
    cy: "37.366%",
    fx: "26.123%",
    fy: "37.366%",
    r: "62.861%",
    id: "sphere-top_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "sphere-top_svg__c",
    cx: 557.5,
    cy: 334.5,
    r: 334.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-top_svg__a)",
    opacity: 0.484,
    x: 147,
    y: 592.5,
    width: 317,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sphere-top_svg__b)",
    xlinkHref: "#sphere-top_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#sphere-top_svg__d)",
    xlinkHref: "#sphere-top_svg__c"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#sphere-top_svg__e)",
    strokeWidth: 3,
    filter: "url(#sphere-top_svg__f)",
    x: 280.5,
    y: 299,
    width: 92,
    height: 44,
    rx: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 309.5h335c6.627 0 12 5.373 12 12s-5.373 12-12 12H12c-6.627 0-12-5.373-12-12s5.373-12 12-12z",
    fill: "url(#sphere-top_svg__g)",
    opacity: 0.529
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-top_svg__h)",
    opacity: 0.752,
    x: 142,
    y: 264.5,
    width: 164,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(340 309.5)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    filter: "url(#sphere-top_svg__i)",
    cx: 12,
    cy: 12,
    r: 12
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSphereTop as ReactComponent };